import { adminApi } from "../../../api/adminClient";
import { cloneFormData, unwrapList, unwrapOne } from "../utils/adminApiHelpers";

export { unwrapList, unwrapOne };

function appendFields(fd, data) {
  fd.append("title_ar", String(data.title_ar ?? "").trim());
  fd.append("title_en", String(data.title_en ?? "").trim());
  fd.append("description_ar", String(data.description_ar ?? "").trim());
  fd.append("description_en", String(data.description_en ?? "").trim());
  const list = data.image;
  const file =
    list && typeof list.length === "number" && list.length > 0
      ? list[0]
      : null;
  if (file instanceof File && file.size > 0) {
    fd.append("image", file);
  }
}

export function buildServiceFormData(data) {
  const fd = new FormData();
  appendFields(fd, data);
  return fd;
}

export function buildServiceFormDataForUpdate(data) {
  const fd = buildServiceFormData(data);
  fd.append("title[ar]", String(data.title_ar ?? "").trim());
  fd.append("title[en]", String(data.title_en ?? "").trim());
  fd.append("description[ar]", String(data.description_ar ?? "").trim());
  fd.append("description[en]", String(data.description_en ?? "").trim());
  return fd;
}

export const fetchServiceList = () => adminApi.get("/services");

export const fetchServiceById = (id) => adminApi.get(`/admin/services/${id}`);

export const createService = (formData) =>
  adminApi.post("/admin/services", formData);

export const updateService = (id, formData) => {
  const fd = cloneFormData(formData);
  fd.append("_method", "PUT");
  return adminApi.post(`/admin/services/${id}`, fd);
};

export const deleteService = (id) => adminApi.delete(`/admin/services/${id}`);
